<template>
    <div class="container" v-title="''">
        <Navigation-bar v-scrollShadow="scrollTop" :title="name"></Navigation-bar>
        <div class="container_content">
            <div id="OnlinePreview" ref="OnlinePreview" v-if="type == 'pdf'"></div>
            <div class="load_more" v-else>无法查看{{type}}类型文件</div>
        </div>
        <div class="operation" v-if="download">
            <button @click="save()">{{buttonText}}</button>
        </div>
        <ImagePreview v-model="image.show" :images="image.list" :start-position="image.index"></ImagePreview>  
    </div>
</template>
<script>
import Pdfh5 from 'pdfh5';
import "pdfh5/css/pdfh5.css"
import {saveFile} from '@js/appInteraction';
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
export default {
    name: 'OnlinePreview',
    components: {
        ImagePreview: ImagePreview.Component
    },
    data() {
        return {
            scrollTop: 0,
            type: '',
            url: '',
            name: '',
            download: !!+this.$route.query.download,
            buttonText:  this.$route.query.buttonText || '下载文档',
            image:{
                list: [],
                index: 0,
                show: false
            }
        }
    },
    created(){
        let url = decodeURIComponent(this.$route.query.file_url),
            type = this.$route.query.type || "",
            name = this.$route.query.name || "";
        if(!type && name){
            type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
        }
        if(!type){
            type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
        }
        if(!name){
            name = url.substr(url.lastIndexOf('/')).substr(1) || '';
        }
        this.url = url;
        this.type = type;
        this.name = name.substr(0, name.lastIndexOf('.')) || name;
    },
    mounted(){
        if(this.url && this.type == 'pdf'){
            this.getPdf();
        }
    },
    methods:{
        getPdf(){
            var pdfh5 = new Pdfh5("#OnlinePreview",{
                pdfurl: this.url,
                zoomEnable: false
            })
            pdfh5.on('success',()=>{
                var imgs = this.$refs.OnlinePreview.querySelectorAll('.pdfViewer .pageContainer > img');
                var images = [];
                if(imgs.length > 0){
                    imgs.forEach((item) => {
                        images.push(item.getAttribute('src'));
                    });
                    this.$set(this.image, 'list', images);
                    let _this =this;
                    imgs.forEach((item,index) => {
                        item.onclick = function(){
                            _this.image.index = index;
                            _this.image.show = true;
                        }
                    });
                }
            })
            pdfh5.on('scroll',(scrollTop)=>{
                if(scrollTop < 1_000_000_000){
                    this.scrollTop = scrollTop;
                }
            })
        },
        save(){
            saveFile(this.url, this.name + '.' + this.type);
        }
    }
};
</script>
<style lang="scss" scoped>
.name{
    max-width: 408px;
    @include ellipsis;
}
.save{
    font-size: 30px;
}
.operation{
    @include bottom-button;
}
</style>